import React, { useState } from "react";
import "./loan-features.css";
import { CheckCircle2, FileText, UserCheck, Wallet, DollarSign, Clock } from "lucide-react";

export default function LoanFeatures() {
  const features = [
    { id: 1, name: "Approval", icon: <CheckCircle2 size={20} />, desc: "Quick, hassle-free approvals with simple documentation." },
    { id: 2, name: "Docs", icon: <FileText size={20} />, desc: "Minimal documents required." },
    { id: 3, name: "Interest", icon: <DollarSign size={20} />, desc: "Flexible, low-interest plans personalized for you." },
    { id: 4, name: "Disbursement", icon: <Wallet size={20} />, desc: "Experience swift fund transfers immediately after approval." },
    { id: 5, name: "Support", icon: <UserCheck size={20} />, desc: "Round-the-clock support when you need it." },
    { id: 6, name: "Tenure", icon: <Clock size={20} />, desc: "Flexible repayment tenure." },
  ];

  const [activeId, setActiveId] = useState(1);

  return (
    <section className="loan-features-section">
      <div className="left-content">

          <h2 className="feature-title mb-4">
             Ultra Short Term <span className="highlight">Loan</span> Features
            </h2>
        <p className="left-tagline">Quick, Transparent and Hassle-free loan with best benefits :</p>

        <div className="left-tabs">
          {features.map((feat) => (
            <div
              key={feat.id}
              className={`left-tab ${activeId === feat.id ? "active" : ""}`}
              onMouseEnter={() => setActiveId(feat.id)}
            >
              <div className="tab-icon">{feat.icon}</div>
              <div className="tab-text">
                <h4>{feat.name}</h4>
                <p>{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="right-content">
        <div className="circle-wrapper">
          <div className="central-circle">
            <span className="central-circle-text">
              Ultra Short<br />Term Loan
            </span>
          </div>
          <div className="bubbles-container">
            {features.map((feat, idx) => (
              <div
                key={feat.id}
                className={`feature-bubble bubble-${idx} ${activeId === feat.id ? "active" : ""}`}
              >
                <div className="bubble-icon">{feat.icon}</div>
                <div className="bubble-title">{feat.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
